import { VscClose } from "react-icons/vsc";

import IconButton from "@Components/IconButton";

import styles from "./DmvCheckDialog.module.scss";

export default function DmvCheckDialog({
  text,
  open,
  setOpen,
}: {
  text: string;
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) {
  const handleHideDialog = () => {
    setOpen(false);
  };

  return open ? (
    <>
      <div className={styles.backdrop} />
      <dialog
        id="dmv-dialog"
        data-testid="dialog"
        className={styles.dialogContainer}
        open={true}
      >
        <div className={styles.header}>
          <div className={styles.dmvInfo}>DMV Information</div>
          <IconButton onClick={handleHideDialog}>
            <VscClose color="#6b97f6" size={30} />
          </IconButton>
        </div>

        <div className={styles.dialogContent}>{text}</div>
      </dialog>
    </>
  ) : null;
}
